import React from 'react'
import StarChartItemDeletePresentation from '../../presentation/starChart.item.delete.presentation/StarChartItemDeletePresentation'
import { StarChartItemDeleteContainerProps } from '../../types/types'

const StarChartItemDeleteContainer: React.FC<StarChartItemDeleteContainerProps> = ({starChartDelete , closeDeletePopup , starChartName}) => {

  return (
    <StarChartItemDeletePresentation starChartDelete={starChartDelete} closeDeletePopup={closeDeletePopup} starChartName={starChartName}/>

  )
}

export default StarChartItemDeleteContainer

